import { Button } from 'react-bootstrap';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';

export enum SessionButtonTypes {
  CANCEL = 'CANCEL',
  SAVE = 'SAVE',
  SAVING = 'SAVING',
  ADD = 'ADD',
  ADDING = 'ADDING',
  CREATE_SESSIONS = 'CREATE_SESSIONS',
  CREATING_SESSIONS = 'CREATING_SESSIONS',
  UPDATE_ALL_REMAINING_SESSIONS = 'UPDATE_ALL_REMAINING_SESSIONS',
  UPDATE_ALL = 'UPDATE_ALL',
  UPDATING = 'UPDATING',
}

const dataQATag: Record<SessionButtonTypes, string | undefined> = {
  [SessionButtonTypes.CANCEL]: 'cancel',
  [SessionButtonTypes.SAVE]: 'saveSession',
  [SessionButtonTypes.SAVING]: 'saveSession',
  [SessionButtonTypes.ADD]: 'addSession',
  [SessionButtonTypes.ADDING]: 'addSession',
  [SessionButtonTypes.CREATE_SESSIONS]: 'createSessions',
  [SessionButtonTypes.CREATING_SESSIONS]: 'createSessions',
  [SessionButtonTypes.UPDATE_ALL_REMAINING_SESSIONS]: 'updateAllRemainingSessions',
  [SessionButtonTypes.UPDATE_ALL]: 'updateAll',
  [SessionButtonTypes.UPDATING]: 'updateAll',
};

type SessionScheduleButtonsProps = {
  type?: SessionButtonTypes;
  disabled: boolean;
  onCancel: () => void;
};

type SessionButtonProps = {
  buttonType: SessionButtonTypes;
  disabled: boolean;
  onClick?: () => void;
  translations: any;
  pendo: any;
};

const SessionButton = ({
  buttonType,
  disabled,
  onClick,
  translations,
  pendo,
}: SessionButtonProps) => {
  const isCancel = buttonType === SessionButtonTypes.CANCEL;
  return (
    <Button
      size='lg'
      onClick={onClick}
      disabled={isCancel ? false : disabled}
      variant={isCancel ? 'secondary' : 'primary'}
      data-qa={pendo[dataQATag[buttonType]]}
      type={isCancel ? 'button' : 'submit'}
    >
      {translations[buttonType]()}
    </Button>
  );
};

const SessionScheduleButtons = ({
  type = SessionButtonTypes.SAVE,
  disabled,
  onCancel,
}: SessionScheduleButtonsProps) => {
  const translations = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.EDIT_MODE;
  const pendo = config.pendo.athena.mentorshipProgram.participantHome.sessions.planSessionFlyout;

  return (
    <div className='button-row' id='session-buttons-row'>
      <SessionButton
        buttonType={SessionButtonTypes.CANCEL}
        onClick={onCancel}
        disabled={disabled}
        translations={translations}
        pendo={pendo}
      />
      <SessionButton
        buttonType={type}
        disabled={disabled}
        translations={translations}
        pendo={pendo}
      />
    </div>
  );
};

export default SessionScheduleButtons;
